import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer className="footer__area">
        <div className="footer__top">
          <div className="container">
            <div className="row">
              {/* Logo & Address */}
              <div className="col-xl-3 col-lg-4 col-md-6">
                <div className="footer__widget">
                  <div className="logo mb-35">
                    <Link to="/">
                      <img src="assets/img/logo/logo.png" alt="DVELGE Logo" />
                    </Link>
                  </div>
                  <div className="footer__content">
                    <p>
                      Apprenez. Progressez. Réussissez avec DVELGE Training.
                    </p>
                    <ul className="list-wrap">
                      <li>
                        1er étage, IMMEUBLE TAOUYA, En Face Maison Des Jeunes De
                        Ratoma, Conakry, Guinée
                      </li>
                      <li>+224 623300992</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Useful Links */}
              <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                <div className="footer__widget">
                  <h4 className="footer__widget-title">Liens utiles</h4>
                  <div className="footer__link">
                    <ul className="list-wrap">
                      <li>
                        <Link to="/">Accueil</Link>
                      </li>
                      <li>
                        <Link to="/courses">Courses</Link>
                      </li>
                      <li>
                        <Link to="/formation-sur-mesure">
                          Formation Sur Mesure
                        </Link>
                      </li>
                      <li>
                        <a
                          href="https://www.dvelgegroup.com"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Site Principal
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://fourniture.dvelgegroup.com"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Site Fourniture
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://logiciel.dvelgegroup.com"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Site Logiciel
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Contact & Social */}
              <div className="col-xl-3 col-lg-4 col-md-6">
                <div className="footer__widget">
                  <h4 className="footer__widget-title">Contactez-nous</h4>
                  <div className="footer__contact-content">
                    <p>Contactez notre équipe dès aujourd’hui</p>
                    <ul className="list-wrap footer__social">
                      <li>
                        <a
                          href="https://www.facebook.com/dvelgegroup"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://x.com/dvelgegroup"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://tiktok.com/@dvelgegroup"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-tiktok"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.instagram.com/dvelgegroup"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.linkedin.com/company/dvelgegroup"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-linkedin-in"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.youtube.com/@dvelgegroup"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-youtube"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer__bottom">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-7">
                <div className="copy-right-text">
                  <p>© 2026 formation.dvelgegroup.com. Tous droits réservés.</p>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
